import type { TripData } from './TripDashboard.types'

export const hasTripAcceptance = (trip: TripData) =>
  trip.tripAcceptanceStatus !== null && trip.tripAcceptanceStatus !== 'NOT_REQUIRED'

export const hasPendingTripAcceptance = (trip: TripData) =>
  trip.tripAcceptanceStatus === 'PENDING'

export interface TripAcceptanceFormValues {
  status: string
}

export const getTripAcceptanceColor = (tripAcceptance: string) => {
  switch (tripAcceptance) {
    case 'ACCEPTED':
      return 'success.main'
    case 'DECLINED':
      return 'primary.light'
    case 'WARNING':
    case 'PENDING':
    default:
      return 'primary.main'
  }
}
